import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addContactAPI } from '../features/AddContactSlice'

function ContactUsForm() {
  const [name, setName] = useState('')
  const [mobile, setMobile] = useState('')
  const [email, setEmail] = useState('')
  const [description, setDescription] = useState('')
  const [showMessage, setShowMessage] = useState(false)
  const dispatch = useDispatch()
  const { sucessMessage, error, loading } = useSelector((state) => state.addContact);

  function submit_ContactForm(e) {
    e.preventDefault()
    dispatch(addContactAPI({ name, mobile, email, description }))
  }

  useEffect(() => {
    if (sucessMessage || error) {
      setShowMessage(true);

      // Hide message after 3 seconds
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      // Cleanup function to clear the timer
      return () => clearTimeout(timer);
    }
  }, [sucessMessage, error]);

  return (
    <div>
      <div className="contact-style-one-area overflow-hidden default-padding">
        <div className="contact-shape" style={{ zIndex: 99 }}>
          <img src="static/img/illustration/14.png" alt="Img Not Found" />
        </div>
        <div className="container">
          <div className="row align-center">
            <div className="contact-stye-one col-lg-5 mb-md-50 mb-xs-40">
              <div className="contact-style-one-info">
                <h4 className="sub-title">Get in Touch Today</h4>
                <h2>Your Success Is Just a Click Away</h2>
                <p>
                  Get in touch with us today for expert support and customize solutions designed to fit your unique needs. Let’s collaborate to turn your goals into reality!
                </p>
                <ul>
                  <li className="wow fadeInUp">
                    <div className="icon">
                      <i className="fas fa-phone-alt" />
                    </div>
                    <div className="content">
                      <h5 className="title">Contact Number</h5>
                      <a href='tel:+918882581143'>+91-888-258-1143</a>
                    </div>
                  </li>
                  <li className="wow fadeInUp" data-wow-delay="300ms">
                    <div className="icon">
                      <i className="fas fa-map-marker-alt" />
                    </div>
                    <div className="info">
                      <h5 className="title">Our Location</h5>
                      <p>
                        B-7, 2nd Floor, Patel Garden Main Rd, opposite Metro Pillar No.786, near Dwarka Mor Metro Station, Block B, New Delhi, Delhi, 110059
                      </p>
                    </div>
                  </li>
                  <li className="wow fadeInUp" data-wow-delay="500ms">
                    <div className="icon">
                      <i className="fas fa-envelope-open-text" />
                    </div>
                    <div className="info">
                      <h5 className="title">Official Email</h5>
                      <a href="mailto:contact@microcode.email">contact@microcode.email</a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="contact-stye-one col-lg-7 pl-60 pl-md-15 pl-xs-15">
              <div className="contact-form-style-one">
                <h2 className="heading">Send us a Message</h2>
                <form

                  className="contact-form contact-form"
                >
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder="Name"
                          type="text"
                          value={name}
                          onChange={(e) => { setName(e.target.value) }}
                        />
                        <span className="alert-error" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Email*"
                          type="email"
                          value={email}
                          onChange={(e) => { setEmail(e.target.value) }}
                        />
                        <span className="alert-error" />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          className="form-control"
                          id="phone"
                          name="phone"
                          placeholder="Phone"
                          type="text"
                          value={mobile}
                          onChange={(e) => { setMobile(e.target.value) }}
                        />
                        <span className="alert-error" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group comments">
                        <textarea
                          className="form-control"
                          id="comments"
                          name="comments"
                          placeholder="Tell Us About Project *"
                          value={description}
                          onChange={(e) => { setDescription(e.target.value) }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <button onClick={submit_ContactForm} type="submit" name="submit" id="submit">
                        <i className="fa fa-paper-plane" /> Get in Touch
                      </button>
                    </div>
                  </div>
                  {/* Alert Message */}
                  {showMessage && (
                    <div className="showmess col-lg-12">
                      {sucessMessage && <p style={{ color: "green" }}>{sucessMessage}</p>}
                      {error && <h2 style={{ color: "red" }}>{error}</h2>}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default ContactUsForm
